"use client";

import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { QueryKeys } from "@/lib/types";
import { getStaffAppointmentRowsFromApi } from "@/lib/services/privateLessonsService";

export function useStaffAppointmentRows() {
  const accessToken = useAccessToken();

  return useQuery({
    queryKey: [QueryKeys.Appointments, "staff-rows"],
    queryFn: () => getStaffAppointmentRowsFromApi(accessToken!),
    enabled: !!accessToken,
    staleTime: 2 * 60 * 1000,
  });
}
